import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import FuelReport from "./fuelReport";
import GlobalItemTransactionReport from "./GlobalItemTransactionReport";
import PendingReturnableReport from "./pendingReturnable";
import { hasPermission } from "../utils/usePermissions";
import ReceiptPendingReturnableReport from "./receiptPendingReturnable";

const ItemLedgerReports = ({ accessOfDepartments, permissions }) => {
  const [selectedReport, setSelectedReport] = useState("");

  /* ================= RENDER SELECTED REPORT ================= */
  const renderReport = () => {
    switch (selectedReport) {
      case "fuelReport":
        return <FuelReport accessOfDepartments={accessOfDepartments} />;

      case "itemLedger":
        return <GlobalItemTransactionReport accessOfDepartments={accessOfDepartments} />;

      case "pendingReturnables":
        return <PendingReturnableReport accessOfDepartments={accessOfDepartments} />;
        case "receiptPendingReturnables":
        return <ReceiptPendingReturnableReport accessOfDepartments={accessOfDepartments} />;

      default:
        return (
          <div className="text-muted mt-4">
            Please select a report
          </div>
        );
    }
  };
  const checkboxStyle = (checked) => ({
    width: "18px",
    height: "18px",
    border: "3px solid #198754",
    borderRadius: "2px",
    appearance: "none",
    cursor: "pointer",
    backgroundColor: checked ? "#198754" : "#fff",
  });

  const labelStyle = { cursor: "pointer" };

  return (
    <div className="container-fluid mt-5">
      {/* ================= HEADER ================= */}
      <div className="card">
        <div className="card-body">
          {/* <h5 className="mb-3">Ledger Wise Reports</h5> */}

          {/* ================= RADIO OPTIONS ================= */}
          <div className="row">

          {hasPermission(permissions, ['globalItemTransaction'])?
          <div className="col-md-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  id="itemLedger"
                  checked={selectedReport === "itemLedger"}
                  onChange={() => setSelectedReport("itemLedger")}
                  style={checkboxStyle(selectedReport === "itemLedger")}
                />
                <label htmlFor="itemLedger" style={labelStyle}>
                  Item Ledger
                </label>
              </div>
            </div>:
            null}

            {hasPermission(permissions, ['fuelReport'])?
            <div className="col-md-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  id="fuelReport"
                  checked={selectedReport === "fuelReport"}
                  onChange={() => setSelectedReport("fuelReport")}
                  style={checkboxStyle(selectedReport === "fuelReport")}
                />
                <label htmlFor="fuelReport" style={labelStyle}>
                  Fuel Ledger
                </label>
              </div>
            </div>:
            null}

            {hasPermission(permissions, ['pendingReturnableChallan'])?
            <div className="col-md-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  id="pendingReturnables"
                  checked={selectedReport === "pendingReturnables"}
                  onChange={() => setSelectedReport("pendingReturnables")}
                  style={checkboxStyle(selectedReport === "pendingReturnables")}
                />
                <label htmlFor="pendingReturnables" style={labelStyle}>
                  Pending Returnables - Delivery Challan
                </label>
              </div>
            </div>:
            null}
                {hasPermission(permissions, ['pendingReturnableReceipt'])?
            <div className="col-md-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  id="receiptPendingReturnables"
                  checked={selectedReport === "receiptPendingReturnables"}
                  onChange={() => setSelectedReport("receiptPendingReturnables")}
                  style={checkboxStyle(selectedReport === "receiptPendingReturnables")}
                />
                <label htmlFor="receiptPendingReturnables" style={labelStyle}>
                  Pending Returnables - Receipt Voucher
                </label>
              </div>
            </div>:
            null}

          </div>

        </div>
      </div>

      {/* ================= REPORT CONTENT ================= */}
      <div className="mt-3">{renderReport()}</div>
    </div>
  );
};

export default ItemLedgerReports;
